import { RecommendationPreferencesData } from './smartChoiceEvents';

export enum breakDownKeys {
  'quality' = 'Quality',
  'benefits' = 'Benefits',
  'convenience' = 'Convenience',
  'personalFit' = 'Personal fit',
  'verification' = 'Updated provider info',
}
export const RecommendationCriteriaMatch = {
  None: 'None',
  All: 'All',
  Some: 'Some',
  Most: 'Most',
};

const criteriaMatchDescriptions = {
  [RecommendationCriteriaMatch.None]: 'No Criteria Met',
  [RecommendationCriteriaMatch.All]: 'All Criteria Met',
  [RecommendationCriteriaMatch.Some]: 'Some Criteria Met',
  [RecommendationCriteriaMatch.Most]: 'Most Criteria Met',
};

const criteriaViewMatchStyle = {
  [RecommendationCriteriaMatch.None]: {
    backgroundColor: '$warning2',
  },
  [RecommendationCriteriaMatch.Some]: {
    backgroundColor: '#F3F3F3',
  },
  [RecommendationCriteriaMatch.Most]: {
    backgroundColor: '#F0F9ED',
  },
  [RecommendationCriteriaMatch.All]: {
    backgroundColor: '#F0F9ED',
  },
};

const criteriaTextMatchStyle = {
  [RecommendationCriteriaMatch.None]: {
    color: '#C24E14',
  },
  [RecommendationCriteriaMatch.Some]: {
    color: '$gray7',
  },
  [RecommendationCriteriaMatch.Most]: {
    color: '$success1',
  },
  [RecommendationCriteriaMatch.All]: {
    color: '$success1',
  },
};

export const getMatchDescription = (match: string): string =>
  criteriaMatchDescriptions[match] ??
  criteriaMatchDescriptions[RecommendationCriteriaMatch.None];

export const getChipbackgroundColor = (match: string): string =>
  criteriaViewMatchStyle[match]?.backgroundColor ??
  criteriaViewMatchStyle[RecommendationCriteriaMatch.None].backgroundColor;

export const getChipTextColor = (match: string): string =>
  criteriaTextMatchStyle[match]?.color ??
  criteriaTextMatchStyle[RecommendationCriteriaMatch.None].color;

export const isSuppressPremiumSmartchoice = (
  suppressStates,
  state: string
): string =>
  suppressStates
    ?.replace(/[\s,]+/g, ',')
    ?.split(',')
    ?.includes(state)
    ? 'Y'
    : 'N';

export const removeSpecialCharactersUsingMatch = (str: string): string =>
  (str?.match(/[a-zA-Z0-9 ]/g) ?? [])?.join('');

export const calculateDaysDifference = (
  date1: Date | string,
  date2: Date | string
): number => {
  const oneDay = 24 * 60 * 60 * 1000;
  const firstDate = new Date(date1).getTime();
  const secondDate = new Date(date2).getTime();
  const difference = Math.abs(firstDate - secondDate);
  return Math.ceil(difference / oneDay);
};

export const getMatchCount = (...args: boolean[]): number =>
  args.filter((i) => i).length;

export const countAllMeasures = (val: number, ...args: boolean[]): number => {
  args.forEach((i) => {
    if (i) {
      val = val + 1;
    }
  });
  return val;
};

export const checkMatch = (item): boolean => item === 'y';

export const getMatchText = (match: string, text: string): string =>
  match === 'All' || match === 'Most' || match === 'Some' ? text : '';

/**
 * Sets Smart Choice preferences in sessionStorage
 *
 * @param preferences - The preferences data from the API
 * @param options - Configuration options
 * @param options.isSuperUser - Whether the current user is a super user
 * @param options.enableSmartChoiceIntroPopup - Whether the intro popup feature is enabled
 *
 * @example
 * setSmartChoiceSessionStorage(preferences, {
 *   isSuperUser: false,
 *   enableSmartChoiceIntroPopup: true
 * });
 */
export const setSmartChoiceSessionStorage = (
  preferences: RecommendationPreferencesData,
  options: { isSuperUser?: boolean; enableSmartChoiceIntroPopup?: boolean }
): void => {
  const { isSuperUser = false, enableSmartChoiceIntroPopup = false } = options;

  if (!enableSmartChoiceIntroPopup) {
    return;
  }

  const { hasDismissedPopover, hasDismissedCoachMarkWeb } = preferences;

  // Handle hasDismissedPopover
  if (
    hasDismissedPopover !== undefined &&
    hasDismissedPopover !== null &&
    (sessionStorage.getItem('hasDismissedPopover') === null || isSuperUser)
  ) {
    sessionStorage.setItem('hasDismissedPopover', hasDismissedPopover);
  } else if (
    hasDismissedPopover !== undefined &&
    hasDismissedPopover === null &&
    (sessionStorage.getItem('hasDismissedPopover') === null || isSuperUser)
  ) {
    sessionStorage.setItem('hasDismissedPopover', 'n');
  }

  // Handle hasDismissedCoachMarkWeb
  if (
    hasDismissedCoachMarkWeb !== undefined &&
    (sessionStorage.getItem('hasDismissedCoachMarkWeb') === null || isSuperUser)
  ) {
    sessionStorage.setItem(
      'hasDismissedCoachMarkWeb',
      hasDismissedCoachMarkWeb
    );
  }
};
